import createClient from "openapi-fetch";
import { ApiError } from "@/shared/utils/apiError";
import type { paths } from "./api.types";

// __API_BASE_URL__ is injected by build.ts (Bun `define`); undefined in dev. The `typeof` guard is load-bearing: a bare ref throws ReferenceError at load.
declare const __API_BASE_URL__: string;

export const api = createClient<paths>({
  baseUrl:
    (typeof __API_BASE_URL__ !== "undefined" ? __API_BASE_URL__ : "") || "/",
  credentials: "include",
});

// Branch on `response.ok`, not `error`: openapi-fetch types `error` as `never` (only success is
// annotated), so checking it narrows the result to `never`. The `error`/`data` casts are the same reason.
export function unwrap<T>(result: {
  data?: T;
  error?: unknown;
  response: Response;
}): T {
  if (!result.response.ok) {
    throw new ApiError(
      result.response.status,
      result.error as { detail?: string; title?: string } | undefined,
    );
  }
  return result.data as T;
}
